
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { Bounce } from 'react-toastify';


const toastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
};


const notifyError = (message) => {
    toast.error(message, {
        ...toastOptions,
    });
};

const notifySuccess = (message) => {
    toast.success(message, {
        ...toastOptions,
    });
};

export { notifyError, notifySuccess };
